import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import styles from './pieChart2.module.css';
import * as echarts from 'echarts';
import {getDzListXueqiRequest, getHzListRequest} from "../../../service/report";

var LIBRARY_COLORS = [
    'rgb(74, 144, 226)', 'rgb(189, 16, 224)','rgb(245, 166, 35)',
    'rgb(76, 175, 80)', 'rgb(248, 231, 28)', 'rgb(126, 211, 33)',
    'rgb(244, 118, 138)', 'rgb(249, 185, 79)', 'rgb(135, 176, 223)',
    'rgb(251, 241, 124)', 'rgb(146, 226, 150)', 'rgb(213, 68, 91)',
    'rgb(168, 130, 213)', 'rgb(132, 156, 133)', 'rgb(220, 186, 64)',
    'rgb(116, 122, 180)', 'rgb(215, 195, 195)', 'rgb(244, 140, 120)',
    'rgb(207, 158, 115)', 'rgb(97, 156, 99)'
];

var myLineChart = null;

class PieChart2 extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'initLineBar',
        ]);

        this.state = {
            dznum: [],
            dzsum: ''
        };

    }

    componentDidMount() {
        getDzListXueqiRequest(sessionStorage.getItem('studentpid'), (data) => {
            console.log(data)

            if (data.ret == '1') {
                var list = data.data.dznum;
                var list0 = [];

                for (var i = 0; i < list.length; i++) {
                    var itemColor = LIBRARY_COLORS[i % LIBRARY_COLORS.length];
                    list0.push({value: list[i].dznum, name: list[i].liyou,itemStyle:{color:itemColor}})
                }

                this.setState({
                    dznum: list0,
                    dzsum: data.data.dzsum[0].dzsum
                });

                this.initLineBar(list0);

            }
        });
    }

    componentDidUpdate() { // 组件更新后触发


    }

    componentWillUnmount (){
        myLineChart.dispose();
    }


    initLineBar(data) {

        const option = {
            tooltip: {
                trigger: 'item'
            },
            legend: {
                top: '2%',
                left: 'center',
                show: false
            },
            series: [
                {
                    // name: 'Access From',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderRadius: 2,
                        borderColor: '#fff',
                        borderWidth: 2
                    },

                    // itemStyle: {
                    //     normal: {
                    //         label: {
                    //             color:'white',
                    //             show: true,
                    //             position: 'inner',
                    //             fontSize: 12,
                    //             fontWeight: 'bold',
                    //             align: "center",
                    //             formatter: function (p) { //指示线对应文字,百分比
                    //                 return p.percent.toFixed(0) + "%";//设置百分比保留几位小数
                    //             }
                    //         },
                    //         labelLine: { //指示线状态
                    //             show: true,
                    //             smooth: 0.2,
                    //             length: 10,
                    //             length2: 20
                    //         }
                    //     }
                    // },


                    label: {
                        show: false,
                        position: 'center',
                        formatter: '{d}%',
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '16',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },

                    data: data
                }
            ]
        };

        myLineChart = echarts.init(document.getElementById('pieChart222'));
        myLineChart.setOption(option, true)

    }

    render() {

        return (
            <div className={styles.root}>
                <div className={styles["div-title"]}>
                    <div className={styles["text-green"]}>点赞</div>
                    <div className={styles["text-red"]}>{this.state.dzsum}</div>
                </div>

                <div className={styles.container}>
                <div id="pieChart222" className={styles.echart} ></div>

                <div className={styles["container-list"]}>
                    {
                        this.state.dznum.map((item, index, array) => {

                            return (
                                <div className={styles["list-item"]}>
                                    <div className={styles.fangkuai}
                                         style={{
                                             background: item.itemStyle.color
                                         }}></div>
                                    <div style={{
                                        color: item.itemStyle.color
                                    }}>
                                        {item.name} {item.value}
                                    </div>

                                </div>
                            )
                        })
                    }

                </div>
                </div>


            </div>

        )
    }
}


export default PieChart2;
